import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import { IconButton } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const SideMenu = ({ options }) => {
  const [activeMenu, setActiveMenu] = useState("/");
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setActiveMenu(
      options.find(
        (m) =>
          m.url === window.location.pathname ||
          m.url === `${window.location.pathname}/`
      ) || {}
    );
  }, [options]);

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={() => setOpen(!open)}
      onKeyDown={() => setOpen(!open)}
    >
      <List>
        <div className="side-menu-header">
          <img src={require("../../resources/logo.png")} width="80%" />
          <IconButton onClick={() => setOpen(!open)}>
            <ArrowBackIosNewIcon />
          </IconButton>
        </div>
        <div className="menu-items">
          {options?.map((menu, index) => {
            return (
              <>
                {
                  <div
                    key={index}
                    className={
                      menu.value === activeMenu.value
                        ? "menu-item menu-item-active"
                        : "menu-item"
                    }
                    onClick={() => {
                      setActiveMenu(menu);
                      navigate(menu.url);
                    }}
                  >
                    <div className="menu-name align-center">
                      <span>{menu.logo}</span>
                      <span className="sidebarmenulabel">{menu.label}</span>
                    </div>
                  </div>
                }
              </>
            );
          })}
        </div>
      </List>
    </Box>
  );

  return (
    <div className="technet-header-container">
      <IconButton onClick={() => setOpen(!open)}>
        {open ? <MenuOpenIcon /> : <MenuIcon />}
      </IconButton>
      <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
        {list("left")}
      </Drawer>
    </div>
  );
};

export default SideMenu;
